export const IDLE_TIMEOUT = 1000 * 60;
export const IDLE_PAYMENT_TIMEOUT = 1000 * 60 * 3;
export const WARNING_TIMEOUT = 1000 * 60;
